import { useState, useMemo, type ReactNode } from 'react';
import { FilteredPlansContext, type FilteredPlansContextValue } from './FilteredPlansContext.context';

interface FilteredPlansProviderProps {
  children: ReactNode;
}

export function FilteredPlansProvider({ children }: FilteredPlansProviderProps) {
  const [count, setCount] = useState(0);

  const value = useMemo<FilteredPlansContextValue>(() => ({ count, setCount }), [count]);

  return (
    <FilteredPlansContext value={value}>
      {children}
    </FilteredPlansContext>
  );
}
